import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import style from "./style.less";
import {FormInputProps} from "./FormDialog";

export interface FormTextInputProps extends FormInputProps {
  value?: string | null
  validate?: (value: string) => boolean
  errorText?: string
  label?: string
}


export const FormTextInput: React.FunctionComponent<{
  props: FormTextInputProps
  defaultValue: string
  onChange: (fieldName: string, value: any) => void
}> = ({ props, defaultValue, onChange }) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const onInputChange = (event: any) => {
    setHasError(props.validate?.(event.target.value) === false)
    onChange(props.name, event.target.value)
  }

  return (
    <TextField
      hiddenLabel
      placeholder={props.placeHolderText}
      className={style.inputField}
      defaultValue={defaultValue}
      onChange={onInputChange}
      inputProps={{ style: { padding: '0.875rem 1rem' } }}
      InputProps={{ style: { borderRadius: '0.5rem' } }}
      error={hasError}
      helperText={hasError ? props.errorText : props.description}
      disabled={props.disabled === true}
      label={props.label}
    />
  )
}
